import {t} from "i18next";
import React, {useState} from "react";

interface ChatFormProps {
  isLoading: boolean;
  onSendMessage: (message: string) => void;
}

const ChatForm = ({onSendMessage, isLoading}: ChatFormProps) => {
  const [message, setMessage] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      onSendMessage(message);
      setMessage("");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex p-4 border-t rounded-b-xl bg-background w-full h-[73px]">
      <input
        type="text"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder={t("ASSISTANT_CHAT_INPUT_PLACEHOLDER")}
        className="w-full p-2 outline-none bg-background text-foreground"
      />
      <button
        type="submit"
        disabled={isLoading || !message.trim()}
        className={`px-4 py-2 bg-gray-200 ${isLoading || !message.trim() ? "text-gray-400" : ""} rounded-full`}
      >
        {t("SEND")}
      </button>
    </form>
  );
};

export default ChatForm;
